import { render, staticRenderFns } from "./groupPage.vue?vue&type=template&id=9e9d7d9c&scoped=true"
import script from "./groupPage.vue?vue&type=script&lang=js"
export * from "./groupPage.vue?vue&type=script&lang=js"
import style0 from "./groupPage.vue?vue&type=style&index=0&id=9e9d7d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9d7d9c",
  null
  
)

export default component.exports